import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import iBMPlexRegularFont from "../../../fonts/IBMPlexSansArabic-Regular.ttf";
import moment from "moment";
import { getToday } from "helpers/utils";

// Register font
Font.register({
  family: "IBM Plex Sans Arabic",
  src: iBMPlexRegularFont,
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 8,
    lineHeight: 1.2,
    backgroundColor: "#fff",
  },
  heading: {
    fontSize: 14,
    textAlign: "center",
    fontWeight: 900,
    marginBottom: 5,
  },
  headingar: {
    fontFamily: "IBM Plex Sans Arabic",

    fontSize: 16,
    textAlign: "center",
    fontWeight: 900,
    marginBottom: 5,
  },
  subHeading: {
    fontSize: 10,
    width: "50%",
    marginBottom: 10,
  },
  colored: {
    color: "#0dcaf0",
    marginTop: 8,
  },
  label1: {
    fontWeight: 700,
    fontSize: 8,
  },
  value1: {
    fontSize: 8,
    flex: 2,
  },
  label: {
    fontWeight: 700,
    fontSize: 8,
    flex: 3,
  },
  value: {
    fontSize: 8,
    flex: 3,
    color: "#666",
  },
  arabic: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: 8,
    textAlign: "right",
    flex: 3,
    color: "#666",
  },
  sectionRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  column1: {
    paddingRight: 10,
    marginBottom: 12,
    gap: 8,
  },
  column: {
    flex: 1,
    paddingRight: 10,
    gap: 6,
  },
  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 4,
  },
  borderBox: {
    borderWidth: 1,
    borderColor: "#000",
    padding: 10,
    marginBottom: 10,
  },
  table: {
    borderWidth: 1,
    borderColor: "#000",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  tableHeaderRow: {
    flexDirection: "row",
    backgroundColor: "#f0f0f0",
    borderBottom: "1px solid #000",
  },
  tableCol: {
    borderRightWidth: 1,
    borderColor: "#000",
    padding: 4,
    justifyContent: "center",
  },
  bold: {
    fontWeight: "700 !important",
    color: "#000",
  },
  lastCol: {
    borderRightWidth: 0,
  },
  headerText: {
    fontSize: 6,
    fontWeight: 700,
    textAlign: "center",
  },
  headerArabic: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: 7,
    textAlign: "center",
  },
  headerPercent: {
    fontSize: 7,
    textAlign: "center",
  },
  cellText: {
    fontSize: 6,
    textAlign: "center",
  },
  cellArabic: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: 8,
    textAlign: "center",
  },
  totalRow: {
    backgroundColor: "#f0f0f0",
  },
  hr: {
    borderBottomWidth: 1,
    borderColor: "#0dcaf0",
    marginBottom: 10,
  },
  createdBy: {
    position: "absolute",
    fontSize: 8,
    bottom: 5,
    left: 10,
    textAlign: "left",
    color: "#a4a4a4",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 8,
    bottom: 5,
    right: 10,
    textAlign: "right",
    color: "#a4a4a4",
  },
});

const colFlex = {
  code: 0.8,
  nature: 2.5,
  quantity: 1.3,
  unitPrice: 1.5,
  gross: 1.5,
  discount: 1.5,
  net: 1.5,
  patient: 1.5,
  insurance: 1.5,
  taxable: 1.5,
  standard: 1.5,
  zero: 1.5,
  vatPercent: 1,
  vatAmount: 1.5,
  totalValue: 1.5,
};
const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") return "";
  return Number(value).toFixed(2);
};
const TaxInvoicePdf = ({ printData, claimFilters, printName }) => {
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 10,
          }}
        >
          {/* <View
            style={{
              width: 50,
              height: 50,
              backgroundColor: "gray",
            }}
          >
            <Text style={{ color: "white", textAlign: "center" }}>QR</Text>
          </View> */}
          <Text style={[styles.heading, styles.headingar]}>
            Invoice Summary / ملخص الفاتورة
          </Text>
        </View>
        <View style={[styles.hr, { marginTop: 16 }]} />
        {/* Top Info */}
        <View style={styles.column1}>
          {/* <View style={styles.itemRow}>
            <Text style={styles.label1}>Email</Text>
            <Text style={styles.value1}>adnan@eradah-pt.com</Text>
          </View> */}
          <View style={styles.itemRow}>
            {/* <Text style={styles.label1}>Invoice No</Text>
            <Text style={styles.value1}>20256C-15043-103722</Text> */}
            <Text style={styles.label1}>Batch Month</Text>
            <Text style={styles.value1}>
              {claimFilters?.start_date &&
              claimFilters?.end_date &&
              moment(claimFilters.start_date).isSame(
                claimFilters.end_date,
                "month"
              )
                ? moment(claimFilters.start_date).format("MMMM/YYYY")
                : ""}
            </Text>
            {/* <Text style={styles.label1}>Batch ID</Text>
            <Text style={styles.value1}>219152</Text> */}
            <Text style={styles.label1}>Claim Type</Text>
            <Text style={styles.value1}>{printData?.claim_type}</Text>
          </View>

          <View style={styles.itemRow}>
            <Text style={styles.label1}>Date & Time</Text>
            <Text style={styles.value1}>
              {moment(getToday()).format("DD-MM-YYYY hh:mm:ss A")}
            </Text>
            {/* <Text style={styles.label1}>Batch Type</Text>
            <Text style={styles.value1}></Text> */}
          </View>
        </View>
        {/* Main Box */}
        <View style={styles.borderBox}>
          {/* Provider and Customer Details */}
          <View style={styles.sectionRow}>
            <View style={styles.column}>
              <View style={styles.itemRow}>
                <Text style={styles.label}>Provider Name</Text>
                <Text style={[styles.value, styles.colored]}>
                  {claimFilters?.branch?.branch_name ||
                    selectedBranch?.branch_name ||
                    ""}
                </Text>
                <Text style={styles.arabic}></Text>
                <Text style={[styles.arabic, styles.bold]}>
                  اسم المرفق الطبي
                </Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={styles.label}>Address</Text>
                <Text style={styles.value}>
                  {printData?.branch_unitno} {printData?.branch_strtname}{" "}
                  {printData?.branch_city}
                </Text>
                <Text style={styles.arabic}></Text>
                <Text style={[styles.arabic, styles.bold]}>العنوان</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={[styles.value, styles.bold]}>Building No</Text>
                <Text style={styles.value}>{printData?.branch_buildngno}</Text>
                <Text style={[styles.arabic, styles.bold]}>رقم المبنى</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={[styles.value, styles.bold]}>District</Text>
                <Text style={styles.value}>{printData?.branch_district}</Text>
                <Text style={[styles.arabic, styles.bold]}>اسم الحي</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={[styles.value, styles.bold]}>Street</Text>
                <Text style={styles.value}>{printData?.branch_strtname}</Text>
                <Text style={[styles.arabic, styles.bold]}>اسم الشارع</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={[styles.value, styles.bold]}>Postal Code</Text>
                <Text style={styles.value}>{printData?.branch_zipcode}</Text>
                <Text style={[styles.arabic, styles.bold]}>صندوق البريد</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={[styles.value, styles.bold]}>City</Text>
                <Text style={styles.value}> {printData?.branch_city}</Text>
                <Text style={styles.arabic}></Text>
                <Text style={[styles.arabic, styles.bold]}>اسم المدينة</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={[styles.value, styles.bold]}>Country</Text>
                <Text style={styles.value}>{printData?.branch_country}</Text>
                <Text style={styles.arabic}> </Text>
                <Text style={[styles.arabic, styles.bold]}> اسم الدولة</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={styles.label}>CR No</Text>
                <Text style={[styles.value, styles.bold]}>
                  {printData?.branch_crno}
                </Text>
                <Text style={[styles.arabic, styles.bold]}>
                  رقم السجل التجاري
                </Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={styles.label}>VAT No</Text>
                <Text style={[styles.value, styles.bold]}>
                  {printData?.branch_vatno}
                </Text>
                <Text style={[styles.arabic, styles.bold]}> الرقم الضريبي</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={styles.label}>Provider Code</Text>
                <Text style={[styles.value, styles.bold]}>
                  {printData?.provider_code}
                </Text>
                <Text style={[styles.arabic, styles.bold]}>رقم الموفر</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.itemRow}>
                <Text style={styles.label}>Customer Name</Text>
                <Text
                  style={[styles.value, styles.colored]}
                >{`${printData?.payer_name} - ${printData?.insurance_name}`}</Text>
                <Text style={styles.arabic}></Text>
                <Text style={[styles.arabic, styles.bold]}>اسم العميل </Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={styles.label}>Payer Vat Number</Text>
                <Text style={styles.value}></Text>
                <Text style={styles.arabic}></Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={styles.label}>Address</Text>
                <Text style={styles.value}>
                  {printData?.insurance_unitno} {printData?.insurance_unitno}{" "}
                  {printData?.insurance_city}
                </Text>
                <Text style={styles.arabic}></Text>
                <Text style={[styles.arabic, styles.bold]}>العنوان</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={[styles.value, styles.bold]}>District</Text>
                <Text style={styles.value}>
                  {printData?.insurance_district}
                </Text>
                <Text style={[styles.arabic, styles.bold]}>اسم الحي</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={[styles.value, styles.bold]}>City</Text>
                <Text style={styles.value}>{printData?.insurance_city}</Text>
                <Text style={styles.arabic}></Text>
                <Text style={[styles.arabic, styles.bold]}>اسم المدينة</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={[styles.value, styles.bold]}>Postal Code</Text>
                <Text style={styles.value}>{printData?.insurance_zipcode}</Text>
                <Text style={styles.value}></Text>
                <Text style={[styles.arabic, styles.bold]}> صندوق البريد</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={[styles.value, styles.bold]}>Street</Text>
                <Text style={styles.value}>
                  {printData?.insurance_strtname}
                </Text>
                <Text style={[styles.arabic, styles.bold]}> اسم الشارع</Text>
              </View>
              <View style={styles.itemRow}>
                <Text style={[styles.value, styles.bold]}>Country</Text>
                <Text style={styles.value}>{printData?.insurance_country}</Text>
                <Text style={styles.arabic}> </Text>
                <Text style={[styles.arabic, styles.bold]}> اسم الدولة</Text>
              </View>
            </View>
          </View>
        </View>
        {/* Table */}
        <View style={styles.table}>
          {/* Table Header */}
          <View style={styles.tableHeaderRow}>
            <View style={[styles.tableCol, { flex: colFlex.code }]}>
              <Text style={styles.headerText}>Code</Text>
              <Text style={styles.headerArabic}>الكود</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.nature }]}>
              <Text style={styles.headerText}>Nature of Services</Text>
              <Text style={styles.headerArabic}> تفاصيل الخدمات</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.quantity }]}>
              <Text style={styles.headerText}>Quantity</Text>
              <Text style={styles.headerArabic}>الكمية</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.gross }]}>
              <Text style={styles.headerText}>Gross Amount</Text>
              <Text style={styles.headerArabic}>المبلغ الإجمالي SAR</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.discount }]}>
              <Text style={styles.headerText}>Discount Amount</Text>
              <Text style={styles.headerArabic}>مبلغ الخصم SAR</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.net }]}>
              <Text style={styles.headerText}>Net Amount</Text>
              <Text style={styles.headerArabic}>المبلغ الصافي SAR</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.patient }]}>
              <Text style={styles.headerText}>Patient Share</Text>
              <Text style={styles.headerArabic}>حصة المريض SAR</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.insurance }]}>
              <Text style={styles.headerText}>Insurance Share</Text>
              <Text style={styles.headerArabic}>حصة التأمين SAR</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.taxable }]}>
              <Text style={styles.headerText}>Taxable amount</Text>
              <Text style={styles.headerArabic}>المبلغ الخاضع للضريبة</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.zero }]}>
              <Text style={styles.headerText}>Zero Rated</Text>
              <Text style={styles.headerArabic}>معدل صفر</Text>
              <Text style={styles.headerPercent}>0% SAR</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.vatPercent }]}>
              <Text style={styles.headerText}>VAT %</Text>
              <Text style={styles.headerArabic}>نسبة VAT</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.vatAmount }]}>
              <Text style={styles.headerText}>VAT Amount</Text>
              <Text style={styles.headerArabic}>مبلغ VAT SAR</Text>
            </View>
            <View
              style={[
                styles.tableCol,
                { flex: colFlex.totalValue, ...styles.lastCol },
              ]}
            >
              <Text style={styles.headerText}>Total Value in SAR</Text>
              <Text style={styles.headerArabic}>القيمة الإجمالية بالريال</Text>
            </View>
          </View>

          {/* Table Row */}
          <View style={styles.tableRow}>
            <View
              style={[
                styles.tableCol,
                { flex: colFlex.nature + colFlex.code + 0.39 },
              ]}
            >
              <Text style={styles.cellArabic}>خدمات الرعاية الصحية</Text>
              <Text style={styles.cellText}>Healthcare Services</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.quantity }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.quantity || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.gross }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.gross_amount || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.discount }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.disc_amnt || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.net }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.net_amnt || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.patient }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.patshre_amnt || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.insurance }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.insshre_amnt || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.taxable }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.txble_amnt || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.zero }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.zerotax_amnt || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.vatPercent }]}>
              <Text style={styles.cellText}>15</Text> {/* static */}
            </View>
            <View style={[styles.tableCol, { flex: colFlex.vatAmount }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.vat_amnt || 0)}
              </Text>
            </View>
            <View
              style={[
                styles.tableCol,
                { flex: colFlex.totalValue, ...styles.lastCol },
              ]}
            >
              <Text style={styles.cellText}>
                {formatNumber(printData?.tot_amnt || 0)}
              </Text>
            </View>
          </View>

          {/* Total Row */}
          <View style={[styles.tableRow, styles.totalRow]}>
            <View
              style={[
                styles.tableCol,
                { flex: colFlex.nature + colFlex.code + 0.39 },
              ]}
            >
              <Text style={styles.cellArabic}>الإجمالي</Text>
              <Text style={styles.cellText}>Total</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.quantity }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.quantity || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.gross }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.gross_amount || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.discount }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.disc_amnt || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.net }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.net_amnt || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.patient }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.patshre_amnt || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.insurance }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.insshre_amnt || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.taxable }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.txble_amnt || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.zero }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.zerotax_amnt || 0)}
              </Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.vatPercent }]}>
              <Text style={styles.cellText}>15</Text>
            </View>
            <View style={[styles.tableCol, { flex: colFlex.vatAmount }]}>
              <Text style={styles.cellText}>
                {formatNumber(printData?.vat_amnt || 0)}
              </Text>
            </View>
            <View
              style={[
                styles.tableCol,
                { flex: colFlex.totalValue, ...styles.lastCol },
              ]}
            >
              <Text style={styles.cellText}>
                {formatNumber(printData?.tot_amnt || 0)}
              </Text>
            </View>
          </View>
        </View>
        <Text style={styles.createdBy} fixed>
          {`Printed by: | ${printName} ${moment().format("lll")}`}
        </Text>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber || ""} of ${totalPages || ""}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default TaxInvoicePdf;
